export const USERS_COLUMNS = ['ID', 'Username', 'Email', 'Role', ''];
